import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex align-center justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-semibold mb-1" }, "Manage Classes"),
  /*#__PURE__*/_createElementVNode("p", null, "Manage Classes and their settings.")
], -1)
const _hoisted_3 = { class: "flex gap-2 items-center justify-end" }
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-lg border border-gray-300 p-12 text-center mt-4"
}
const _hoisted_5 = { class: "flex flex-col items-center justify-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mt-4 text-gray-500" }, "Loading classes...", -1)
const _hoisted_7 = { class: "p-8 relative" }
const _hoisted_8 = { class: "flex items-center justify-start mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Add Class"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-tertiary" }, "Enter new Class details.")
], -1)
const _hoisted_10 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-500 text-sm rounded-md flex items-center justify-start gap-2"
}
const _hoisted_11 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Class Name", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_14 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Subject", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_17 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Grade/Year", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_20 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Language", -1)
const _hoisted_22 = { class: "text-center relative h-5 w-5 d-block ml-2" }
const _hoisted_23 = { class: "absolute z-50 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_24 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Learning Mode", -1)
const _hoisted_26 = { class: "text-center relative h-5 w-5 d-block ml-2" }
const _hoisted_27 = { class: "absolute z-50 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_28 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8 flex-col gap-2" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}

import { ref, computed, watch, onMounted } from "vue";
import { useUserStore } from "@/stores/userStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from "@/stores/subjectStore";
import { useAdminStore } from "@/stores/adminStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useFilterStore } from "@/stores/filterStore";
import { useActivityLogStore } from "@/stores/activityLogStore";
import { FormKitNode } from "@formkit/core";
import {
  TrashIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { unionBy } from "lodash";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'
import ClassesTableComponent from '@/modules/main/components/ClassesTableComponent.vue';
import * as XLSX from "xlsx";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClassesViewNew',
  setup(__props) {

const { t } = useI18n();

// stores
const subjectStore = useSubjectStore();
const learnerStore = useLearnerStore();
const adminStore = useAdminStore();
const filterStore = useFilterStore();
const userStore = useUserStore();
const schoolStore = useSchoolStore();
const activityLogStore = useActivityLogStore();

const classGroups = computed(() => schoolStore.currentSchoolStructure?.classGroups || []);
const learners = learnerStore.getSchoolLearners;

function getLearnerCountByClassId(classId: string, subjectId: string): number {
  return learners.filter((learner: any) =>
    learner.classes.some(
      (cls: any) => cls._id === classId && cls.subject?._id === subjectId
    )
  ).length;
}

function exportClassesToExcel(classes: any[]) {
  void activityLogStore.logGenericActivityEvent({
    school: filterStore.selectedFilters.school || schoolStore.currentSchoolStructure?._id || null,
    entityType: "class-group",
    actionType: "export",
    details: {
      note: `Exported classes - ${classes.length} class records`
    },
  });

  const getSubjectName = (subjectId: string) => {
    const subject = subjectStore.subjects.find(s => s.id === subjectId);
    return subject?.name || subjectId;
  };

  const getLanguageLabel = (code: string) => {
    const lang = schoolStore.locales.find((l) => l.code === code);
    return lang?.name || code;
  };

  const headers = ['Class', 'Subject', 'Grade', 'Students', 'Teacher', 'Language', 'Learning Mode'];

  const rows = classes.map((cls) => [
    cls.name,
    getSubjectName(cls.subject),
    Number(cls.gradeLevel),
    getLearnerCountByClassId(cls._id, cls.subject),
    cls.admins?.map((a: any) => `${a.firstName} ${a.lastName}`).join(', ') || 'None assigned',
    getLanguageLabel(cls.preferredLanguage),
    cls.learningMode || 'default'
  ]);

  // Sort alphabetically by first column ("Class")
  rows.sort((a, b) => a[0].localeCompare(b[0]));

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);

  // ✅ Bold the headers manually
  headers.forEach((_, index) => {
    const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
    if (worksheet[cellRef]) {
      worksheet[cellRef].s = {
        font: { bold: true }
      };
    }
  });

  // ✅ Enable column filters
  worksheet['!autofilter'] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: 0 },
      e: { r: 0, c: headers.length - 1 },
    }),
  };

  // ✅ Set column widths
  worksheet['!cols'] = Array(headers.length).fill({ wch: 20 });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');

  // ⏰ Timestamp in YYYYMMDD_HHMM format
  const timestamp = new Date().toISOString().replace(/[-:]/g, '').slice(0, 13).replace('T', '_');

  // 🏫 School name (sanitized)
  const schoolName = (schoolStore.getCurrentSchool?.name || 'School').replace(/\s+/g, '_');

  const filename = `Export_Classes_${schoolName}_${timestamp}.xlsx`;

  // ✅ Use writeFile with cell styles enabled
  XLSX.writeFile(workbook, filename, {
    bookType: 'xlsx',
    cellStyles: true // Required to preserve bold styling
  });
}

const addClassModal = ref<boolean>(false);
const formErrorAlert = ref<boolean>(false);
const formError = ref<string | null>(null);
const buttonIsDisabled = ref(false);
const loading = ref<boolean>(false);
const showExportButton = process.env.VUE_APP_BULK_EXPORT_BUTTON === "true";

const pages = [{
  name: 'Manage Classes',
  path: '/classesnew'
}];

const addClass = () => {
  newClass.value.preferredLanguage = 'default';
  addClassModal.value = true;
};

const closeModals = () => {
  addClassModal.value = false;
};

// Reactive object for new class data
const newClass = ref({
  name: "",
  code: "",
  subject: "",
  gradeLevel: "",
  preferredLanguage: 'default',
  admins: null,
  school: schoolStore.currentSchoolStructure?._id,
  schoolGroup: schoolStore.currentSchoolStructure?.schoolGroup
});

// compare subject id with the user id to see if it is maths or english
const englishSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'english')?.id)
const mathsSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'maths')?.id)

// Helper functions to check subject type
function isEnglishClass(subjectId: string) {
    return subjectId === englishSubjectId.value
}

function isMathsClass(subjectId: string) {
    return subjectId === mathsSubjectId.value
}

const availableSubjects = computed(() => {
  return (schoolStore.getCurrentSchool?.subjectsAvailable || [])
    .map(subject => String(subject._id));
});

const hasEnglish = computed(() =>
  availableSubjects.value.some(subjectId => isEnglishClass(subjectId))
);

const hasMaths = computed(() =>
  availableSubjects.value.some(subjectId => isMathsClass(subjectId))
);

// Build options array
const subjectOptions = computed(() => {
  const opts: { label: string; value: string }[] = []
  if (mathsSubjectId.value && schoolStore?.getCurrentSchool?.subjectsAvailable.some(s => s._id === mathsSubjectId.value)) {
    opts.push({ label: 'Maths', value: mathsSubjectId.value })
  }
  if (englishSubjectId.value && schoolStore?.getCurrentSchool?.subjectsAvailable.some(s => s._id === englishSubjectId.value)) {
    opts.push({ label: 'English', value: englishSubjectId.value })
  }
  return opts
})

// Detect if we only have one choice
const singleSubject = computed(() =>
  subjectOptions.value.length === 1 ? subjectOptions.value[0] : null
)

// When we mount (or whenever subjectOptions changes), if singleSubject is set, auto‑assign
watch(singleSubject, (s) => {
  if (s) {
    newClass.value.subject = s.value
  }
}, { immediate: true })

const gradeOptions = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
];

const languageOptions = computed(() => {
  const preferred = schoolStore.currentSchoolStructure?.preferredLang || 'Default';
  return [
    { label: `${preferred} (default)`, value: 'default' },
    ...(schoolStore.locales || []).map(lang => ({ label: lang.code, value: lang.code }))
  ];
});

const teacherOptions = computed(() => {
  const seen = new Set();
  const options = (schoolStore.currentSchoolStructure?.allClassGroupAdmins ?? [])
     .filter(admin => admin && admin._id && !seen.has(admin._id) && seen.add(admin._id))
    .map(admin => {
      const fullName = `${admin.firstName} ${admin.lastName}`.trim().replace(/\s+/g, ' ');
      return {
        label: fullName,
        value: admin._id,
      };
    })
    .sort((a, b) => {
      const lastNameA = a.label.split(' ').slice(-1)[0].toLowerCase();
      const lastNameB = b.label.split(' ').slice(-1)[0].toLowerCase();
      return lastNameA.localeCompare(lastNameB);
    });

  // Add blank option at the top
  return [
    { label: "Assign Teacher", value: "" },
    ...options
  ];
});

function classGroupNameExists(name: string, subjectId: string): boolean {
  const structure = schoolStore.currentSchoolStructure;
  if (!structure || !structure.classGroups) return false;
  return structure.classGroups.some(
    (group) => group.name?.trim().toLowerCase() === name.trim().toLowerCase() &&
      (subjectId ? group.subject === subjectId : true)
  );
}

const saveNewClass = async () => {
  buttonIsDisabled.value = true;
  loading.value = true;
  formErrorAlert.value = false;

  try {
    const { name, subject, code, gradeLevel, preferredLanguage, learningMode, admins, school, schoolGroup } = newClass.value;

    // duplicate class name check AFTER validation passed
    if (classGroupNameExists(name, subject)) {
      formErrorAlert.value = true;
      formError.value = 'There is already another Class in the School with the same Name and Subject. You might be trying to create a duplicate Class.';
      loading.value = false;
      return;
    }

    const payload = {
      name: name,
      code: code || name?.replace(/\s+/g, '').toLowerCase(),
      subject,
      gradeLevel,
      preferredLanguage,
      learningMode,
      admin: admins ? admins : null,
      school: schoolStore.currentSchoolStructure?._id,
      schoolGroup: schoolStore.currentSchoolStructure?.schoolGroup
    };

    const response = await schoolStore.newClass(payload);

    if (response._id) {
      showToast({
        text: 'Class successfully added.',
        type: 'success',
        icon: CheckCircleIcon
      });
    } else {
      showToast({
        text: 'Class could not be added.',
        type: 'error',
        icon: ExclamationCircleIcon
      });  
    }

    addClassModal.value = false;

    // Reset form but preserve school/schoolGroup and auto-assign subject for single-subject schools
    newClass.value = {
      name: '',
      code: '',
      subject: singleSubject.value ? singleSubject.value.value : '',
      gradeLevel: '',
      preferredLanguage: 'default',
      learningMode: 'default',
      admins: null,
      school: schoolStore.currentSchoolStructure?._id,
      schoolGroup: schoolStore.currentSchoolStructure?.schoolGroup
    };
  } catch (error) {
    formErrorAlert.value = true;
    formError.value = 'An error occurred while saving. Please check your inputs.';
    console.error(error);
  } finally {
    loading.value = false;
    buttonIsDisabled.value = false;
  }
};

const learningModeOptions = computed(() => [
  { label: 'Default', value: 'default' },
  ...schoolStore.getLearningModes.map(mode => ({
    label: mode.label,
    value: mode.value
  }))
]);

// Check if school is set to Lingo v2 only
const isV2Only = computed(() => schoolStore.lingoMode === 'v2');
//hide learning mode and allow default as the value when adding
const showLearningMode = computed(() => false); 

// Refresh class data on page load to ensure fresh data
onMounted(async () => {
  const schoolId = schoolStore.currentSchoolStructure?._id;
  if (schoolId) {
    await schoolStore.fetchSchoolStructure(schoolId);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_title, { pages: pages }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        showExportButton
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "text-gray-700 text-semibold py-2 px-6 rounded-lg flex gap-1 border border-gray-300 flex gap-2 flex-row justify-center items-center flex-wrap",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (exportClassesToExcel(classGroups.value)))
            }, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-export',
                title: 'rl export',
                "aria-hidden": "true"
              }),
              _createTextVNode(" Export ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white flex flex-row justify-center items-center flex-wrap",
          onClick: addClass
        }, "Add Class")
      ])
    ]),
    (_unref(schoolStore).schoolStructureLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_spinner_loader, { color: 'text-blue-600' }),
            _hoisted_6
          ])
        ]))
      : (_openBlock(), _createBlock(ClassesTableComponent, { key: 1 })),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-3xl',
      open: addClassModal.value,
      onLocalModalOpen: _cache[7] || (_cache[7] = ($event: any) => (addClassModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-add-teacher',
                title: 'rl add teacher',
                class: "h-12 w-12 text-blue-600 mx-auto mb-4",
                "aria-hidden": "true"
              }),
              _hoisted_9
            ]),
            (formErrorAlert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-alert-error',
                    title: 'rl alert error',
                    class: "h-8 w-8 text-red-500",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", null, _toDisplayString(formError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "login-form",
                actions: false,
                config: { validationVisibility: 'submit' },
                onSubmit: saveNewClass
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "Class Name",
                      placeholder: "Class Name",
                      modelValue: newClass.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newClass.value.name) = $event)),
                      validation: "required|length:0,20",
                      "input-class": "w-full",
                      "outer-class": "w-full",
                      "validation-messages": {
                      length: 'Class Name must be 20 characters or fewer.',
                      required: 'Class Name is required.'
                    }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_12,
                        _hoisted_13
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-messages"]),
                    (!singleSubject.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "select",
                          name: "Subject",
                          placeholder: "Subject",
                          modelValue: newClass.value.subject,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newClass.value.subject) = $event)),
                          options: subjectOptions.value,
                          "input-class": "w-full",
                          "outer-class": "w-full",
                          validation: "required"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_15,
                            _hoisted_16
                          ]),
                          suffix: _withCtx(({ node }) => [
                            (!node.context?.state.valid && node.context?.state.validationVisible)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_rl_icon, {
                                    icon: "rl-alert-error",
                                    title: "Error",
                                    "aria-hidden": "true"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      name: "Grade/Year",
                      label: "Grade/Year",
                      placeholder: "Select Grade/Year",
                      validation: "required",
                      modelValue: newClass.value.gradeLevel,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newClass.value.gradeLevel) = $event)),
                      options: gradeOptions,
                      "input-class": "w-full",
                      "outer-class": "w-full"
                    }, {
                      label: _withCtx(() => [
                        _hoisted_18,
                        _hoisted_19
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    (!isV2Only.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 1,
                          type: "select",
                          name: "Language",
                          label: "Language",
                          placeholder: "Language",
                          modelValue: newClass.value.preferredLanguage,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((newClass.value.preferredLanguage) = $event)),
                          options: languageOptions.value,
                          "input-class": "w-full",
                          "outer-class": "w-full"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, [
                              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_23, [
                                _createVNode(_component_rl_icon, {
                                  icon: 'rl-question-cirlce',
                                  title: 'rl question cirlce',
                                  "aria-hidden": "true"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  'This sets the Language of instruction for this Class, overriding the School Default if needed. This can be overridden by Student. Note that English language jurisdictions have distint spelling, notational conventions, units of measure, etc.',
                                  "bottom",
                                  { html: true }
                                ]
                              ])
                            ])
                          ]),
                          suffix: _withCtx(({ node }) => [
                            (!node.context?.state.valid && node.context?.state.validationVisible)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_rl_icon, {
                                    icon: "rl-alert-error",
                                    title: "Error",
                                    "aria-hidden": "true"
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    (showLearningMode.value)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 2,
                          type: "select",
                          name: "learningMode",
                          label: "Learning Mode",
                          placeholder: "Learning Mode",
                          modelValue: newClass.value.learningMode,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newClass.value.learningMode) = $event)),
                          options: learningModeOptions.value,
                          "input-class": "w-full",
                          "outer-class": "w-full"
                        }, {
                          label: _withCtx(() => [
                            _hoisted_25,
                            _createElementVNode("span", _hoisted_26, [
                              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_27, [
                                _createVNode(_component_rl_icon, {
                                  icon: 'rl-question-cirlce',
                                  title: 'rl question cirlce',
                                  "aria-hidden": "true"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  'This sets the Language of instruction for this Class, overriding the School Default if needed. This can be overridden by Student. Note that English language jurisdictions have distint spelling, notational conventions, units of measure, etc.',
                                  "bottom",
                                  { html: true }
                                ]
                              ])
                            ])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "options"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      label: "Teacher",
                      placeholder: "None assigned",
                      modelValue: newClass.value.admins,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((newClass.value.admins) = $event)),
                      options: teacherOptions.value,
                      "outer-class": "w-full"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: buttonIsDisabled.value || loading.value,
                      class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 disabled:cursor-not-allowed w-full"
                    }, [
                      (loading.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                          ]))
                        : _createCommentVNode("", true),
                      _createTextVNode(" Add Class ")
                    ], 8, _hoisted_29),
                    _createElementVNode("button", {
                      onClick: closeModals,
                      class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})